import Vue from 'vue';

if (process.env.NODE_ENV != 'local') {
	Vue.config.productionTip = false;
	Vue.config.devtools = false;
}

import {
	Tooltip,
	Row,
	Col,
	Select,
	Option,
	Input,
	Dialog,
	Table,
	TableColumn,
	Checkbox,
	DatePicker,
	Pagination,
	Tree,
	Form,
	FormItem,
	Tabs,
	TabPane,
	Collapse,
	CollapseItem,
	Button,
	Upload,
	TimePicker,
	Image,
	Radio
} from 'element-ui';

import App from './App.vue';
import store from './store';

// router setup
import router from './routes/router';

import Plugin from '@sfaas/common';
import { Util } from '@sfaas/util';
import '@/assets/sass/index.scss';

Vue.component(Select.name, Select);
Vue.component(Table.name, Table);
Vue.component(TableColumn.name, TableColumn);
Vue.component(DatePicker.name, DatePicker);
Vue.component(Input.name, Input);
Vue.component(Option.name, Option);
Vue.component(Checkbox.name, Checkbox);
Vue.component(Row.name, Row);
Vue.component(Col.name, Col);
Vue.component(Tabs.name, Tabs);
Vue.component(TabPane.name, TabPane);
Vue.component(Button.name, Button);
Vue.component(Form.name, Form);
Vue.component(FormItem.name, FormItem);
Vue.component(Collapse.name, Collapse);
Vue.component(CollapseItem.name, CollapseItem);
Vue.component(Pagination.name, Pagination);
Vue.component(Tree.name, Tree);
Vue.component(Tooltip.name, Tooltip);
Vue.component(Dialog.name, Dialog);
Vue.component(Upload.name, Upload);
Vue.component(TimePicker.name, TimePicker);
Vue.component(Image.name, Image);
Vue.component(Radio.name, Radio);
Vue.use(Plugin);
Vue.use(Util);

// import moment from 'moment';
// Vue.use(moment);
// Vue.prototype.$moment = moment;

new Vue({
	store,
	el: '#app',
	render: h => h(App),
	router
});
